// Mock data for HorseGO - Horse Transportation Platform

export const heroData = {
  tagline: [
    "We match riders with commercial transporters",
    "to fill empty or partially empty loads,",
    "ensuring quality transportation at the best prices &",
    "reducing CO2 emissions"
  ],
  subtitle: "Get quotes, Compare & Book quality horse transportation in no time!",
  description: "HorseGO™ is an on-demand app that connects you with over 500 transporters that have capacity or driving empty along your route to Save Time, offer Flexibility and the Best Prices.",
  highlight: "The well-being of your horse is our highest priority!",
  appStoreLink: "#",
  playStoreLink: "#"
};

export const featuresData = [
  {
    id: 1,
    title: "Quality Transport",
    description: "Our Commitment to provide only transportation that meets quality standards to protect your horse and your investment.",
    icon: "Shield"
  },
  {
    id: 2,
    title: "Best Price Guarantee",
    description: "We work closely with our transport partners to get you the best offers in the market. This way you can easily compare and book.",
    icon: "BadgeDollarSign"
  },
  {
    id: 3,
    title: "Safety",
    description: "Your horse is in the best hands. We do the work to bring you experienced and specialized horse transporters in Morocco.",
    icon: "ShieldCheck"
  },
  {
    id: 4,
    title: "Save Time",
    description: "Don't spend hours searching for transporters - we have the best. Simply submit a request and wait for offers to come.",
    icon: "Clock"
  },
  {
    id: 5,
    title: "24/7 Support",
    description: "Our team of experts is available 24/7 to support you throughout the journey, from preparing your horse to meeting all custom formalities.",
    icon: "HeadphonesIcon"
  }
];

export const stepsData = [
  {
    step: 1,
    title: "Download the HorseGO App",
    action: "Download",
    link: "#"
  },
  {
    step: 2,
    title: "Give us your destination",
    action: "Enter Route",
    link: "#"
  },
  {
    step: 3,
    title: "Book the winning offer",
    action: "Get Quotes",
    link: "#"
  }
];

export const serviceTiersData = [
  {
    id: 1,
    name: "Premium™",
    tagline: "Comfort & service at its best",
    features: [
      "High-quality transport guarantee",
      "Excellently aligned with individual needs",
      "Fastest route, direct destination only",
      "Exclusive private transport for your horse(s)",
      "Driving and resting times monitored",
      "Top-of-the-line vehicles",
      "Extra services: cameras, AC, temperature monitoring",
      "Drivers are professional competitors & trainers",
      "20+ years of experience"
    ],
    rating: 5,
    image: "https://images.unsplash.com/photo-1616432043562-3671ea2e5242?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwxfHx0cmFuc3BvcnQlMjB0cnVja3xlbnwwfHx8fDE3Njg4NTk2OTB8MA&ixlib=rb-4.1.0&q=85&w=400"
  },
  {
    id: 2,
    name: "Single™",
    tagline: "Service & on demand",
    features: [
      "Perfect if you aren't flexible with dates",
      "Fastest route, direct destination only",
      "Private transport available",
      "Ideal for stable moves & tournaments",
      "Vehicles in great condition (2-6 horses)",
      "Limited extra services available",
      "10+ years of experience",
      "High-quality transport guarantee"
    ],
    rating: 5,
    image: "https://images.unsplash.com/photo-1591768793355-74d04bb6608f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHw0fHx0cmFuc3BvcnQlMjB0cnVja3xlbnwwfHx8fDE3Njg4NTk2OTB8MA&ixlib=rb-4.1.0&q=85&w=400"
  },
  {
    id: 3,
    name: "Lift™",
    tagline: "Flexible dates get lower rates",
    features: [
      "Premium/Single trips at lower rates",
      "Flexible dates required",
      "No-to-few stopovers on direct trips",
      "Drivers pick up along their way",
      "Vehicles capacity: 2-6 horses",
      "100% transparency on transport",
      "High-quality transport guarantee"
    ],
    rating: 5,
    image: "https://images.pexels.com/photos/30536323/pexels-photo-30536323.jpeg?w=400"
  },
  {
    id: 4,
    name: "Hop On Hop Off™",
    tagline: "Share the cost with others",
    features: [
      "Join regular scheduled routes",
      "Travel with horses going same direction",
      "Benefit from attractive shared rates",
      "Flexible pick-up and drop-off dates",
      "Monitored driving and resting times",
      "Vehicles capacity: 6-14 horses",
      "100% transparency guaranteed",
      "High-quality transport guarantee"
    ],
    rating: 5,
    image: "https://images.pexels.com/photos/31311877/pexels-photo-31311877.jpeg?w=400"
  }
];

export const testimonialsData = [
  {
    id: 1,
    name: "Karim K.",
    location: "Casablanca",
    rating: 5,
    text: "HorseGO made transporting my mare from Casablanca to Marrakech incredibly easy. The driver was professional, and my horse arrived calm and happy!",
    image: "https://images.pexels.com/photos/15499134/pexels-photo-15499134.jpeg?w=300"
  },
  {
    id: 2,
    name: "Abderahim A.",
    location: "Marrakech",
    rating: 5,
    text: "I've used HorseGO for 3 trips now. The price matching and quality guarantee give me complete peace of mind every time.",
    image: "https://images.pexels.com/photos/16884193/pexels-photo-16884193.jpeg?w=300"
  },
  {
    id: 3,
    name: "Aamar R.",
    location: "Rabat",
    rating: 5,
    text: "The service saved me 40% on transport costs! My horse shared the journey with two others going the same route. Brilliant concept!",
    image: "https://images.pexels.com/photos/32539558/pexels-photo-32539558.jpeg?w=300"
  },
  {
    id: 4,
    name: "Ahmed T.",
    location: "Benslimane",
    rating: 5,
    text: "All paperwork was handled seamlessly by their team. They guided me through every step of the process. Highly recommend!",
    image: "https://images.pexels.com/photos/7882862/pexels-photo-7882862.jpeg?w=300"
  }
];

export const partnersData = [
  {
    id: 1,
    name: "GroomGO",
    description: "HorseGO and GroomGO have partnered to offer riders the comfort to get your horse home safely with the best transport service."
  },
  {
    id: 2,
    name: "VetGO",
    description: "HorseGO and VetGO have partnered to offer riders the comfort of finding specialised clinics all at a click away."
  }
];

export const infoCardsData = [
  {
    id: 1,
    title: "Price Matching",
    description: "Our commitment to you is that you'll find competitive prices every day, and if you find one from a qualified transporter that's lower on comparable quality, we'll match it."
  },
  {
    id: 2,
    title: "Travel Insurance",
    description: "When you book with us your horse is insured! Simply submit a request and get coverage for national or international trips."
  }
];

export const statsData = {
  transporters: "500+",
  countries: "25+",
  tripsCompleted: "10,000+",
  happyHorses: "15,000+"
};

export const navLinks = [
  { name: "Home", href: "/" },
  { name: "How it Works", href: "#how-it-works" },
  { name: "Services", href: "#services" },
  { name: "About Us", href: "#about" },
  { name: "Transporters", href: "/drivers" },
  { name: "Contact", href: "#contact" }
];

export const footerLinks = {
  company: [
    { name: "About Us", href: "#" },
    { name: "Careers", href: "#" },
    { name: "Press", href: "#" },
    { name: "Blog", href: "#" }
  ],
  support: [
    { name: "Help Center", href: "#" },
    { name: "Safety", href: "#safety-section" },
    { name: "Terms of Service", href: "#" },
    { name: "Privacy Policy", href: "/privacy-policy" }
  ],
  services: [
    { name: "Premium Transport", href: "#" },
    { name: "Single Transport", href: "#" },
    { name: "Lift Service", href: "#" },
    { name: "Hop On Hop Off", href: "#" }
  ]
};
